import { createTheme } from "@mui/material/styles";

export const theme = {
  palette: {
    primary: {
      main: "#0070f7",
      dark: "#1135b7",
      light: "#30d8fc",
    },
    secondary: {
      main: "#ef169c",
      dark: "#b90c98",
      light: "#f96ed0",
    },
    tirciary: {
      main: "#371793",
      dark: "#16116e",
      light: "#6945d7",
    },
    text: {
      main: "#fee399",
      dark: "#000000",
      light: "#ffffff",
    },
    border: {
      main: "#f38153",
      dark: "#d36839",
      light: "#f7a378",
    },
    error: {
      main: "#f44336",
      dark: "#d32f2f",
      light: "#e57373",
    },
    warning: {
      main: "#ff9800",
      dark: "#f57c00",
      light: "#ffe082",
    },
    info: {
      main: "#2196f3",
      dark: "#1976d2",
      light: "#90caf9",
    },
    success: {
      main: "#4caf50",
      dark: "#2e7d32",
      light: "#c8e6c9",
    },
    black: "#000000",
    white: "#ffffff",
    grey: {
      main: "#808080",
      light: "#d3d3d3",
      dark: "#606060",
    },
  },
  typography: {
    fontFamily: `"Poppins", sans-serif;`,
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
    toast: 9999, // custom zIndex for your Toast
  },
};
